export const ArchivedBadge = () => {
  return (
    <div className="flex items-center p-1 rounded bg-neutral-300 text-gray-700 text-xs font-medium">
      Archived
    </div>
  );
};
